// extracted by mini-css-extract-plugin
export default {"container":"t0Hm_9","separator":"H_bt39","date":"_g1jbK","location":"TY44d9","mobile":"qiYorH"};